"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlossaryService = void 0;
const react_1 = __importStar(require("react"));
const spa_core_1 = require("@episerver/spa-core");
const react_router_1 = require("react-router");
const useOnClickOutside_1 = __importDefault(require("app/hooks/useOnClickOutside"));
const GlossaryService = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const popRef = (0, react_1.useRef)(null);
    const [glossaryTermsArr, setGlossaryTermsArr] = (0, react_1.useState)();
    const api = (0, spa_core_1.useContentDeliveryAPI)();
    const ctx = (0, spa_core_1.useEpiserver)();
    const location = (0, react_router_1.useLocation)();
    const [glossaryItem, setGlossaryItem] = (0, react_1.useState)({ title: '', url: '', description: '', hasMainbody: false });
    const [firstRender, setFirstRender] = (0, react_1.useState)(true);
    let initialized = false;
    const [glossaryPosition, setGlossaryPosition] = (0, react_1.useState)({
        offsetY: 0,
        offsetX: 0,
        isRight: false,
        opacity: 0,
        bubble: 0
    });
    const excludedString = ((_b = (_a = props.settings) === null || _a === void 0 ? void 0 : _a.excludedNodes) === null || _b === void 0 ? void 0 : _b.value) || (typeof ((_c = props.settings) === null || _c === void 0 ? void 0 : _c.excludedNodes) === 'string' ? props.settings.excludedNodes : (_e = (_d = props.settings) === null || _d === void 0 ? void 0 : _d.excludedNodes) === null || _e === void 0 ? void 0 : _e.value);
    const excludeNodes = excludedString ? excludedString.split('\n') : '';
    let glossaryState = props.glossaryActive;
    const hasOnlyTextNodes = (node) => {
        let ret = true;
        node.forEach((n) => {
            if (n.nodeType !== 3)
                ret = false;
        });
        return ret;
    };
    const findAndReplace = (node) => {
        const originalText = node.textContent;
        let textInProcess = originalText;
        let newText = '';
        glossaryTermsArr.forEach((g, i) => {
            // skipping words already found.
            // adding spaces around to regex find if needle is first or last word.
            if (g.terms && g.terms.length > 0 && !g.found) {
                const termsArr = g.terms.filter(t => t.trim().length > 0);
                if (termsArr.length > 0) {
                    const searchTerm = termsArr.join('($|[,. !?;:])|([,. !?;:]|^)');
                    const pattern = new RegExp('(([,. !?;:]|^)' + searchTerm + '([,. !?;:]|\$))+(?![^>]*\</button)', 'i');
                    newText = textInProcess.replace(pattern, function (m) {
                        g.found = true;
                        return ` <button aria-controls="glossarypop" aria-expanded="${glossaryItem.title !== '' ? 'true' : 'false'}" class="glossaryActive" data-content="${i}">${m.trim()}</button> `;
                    });
                    if (newText && newText !== '')
                        textInProcess = newText;
                }
            }
        });
        if (newText && newText !== originalText)
            node.innerHTML = newText;
    };
    const findTextNodes = (node) => {
        if (node) {
            //find all wanted nodes
            let nodes = node.querySelectorAll(excludeNodes === '' ? '*' : `*:not(${excludeNodes})`);
            // filter out nodes which doesn't have text content
            let nodes2 = Array.from(nodes).filter((node) => hasOnlyTextNodes(node.childNodes));
            // run thru all text content, pick only nodes with only text content ie text inside div which holds p is not checked, only
            nodes2.forEach((o) => {
                if (o.textContent !== '')
                    findAndReplace(o);
            });
        }
    };
    const backToMenuKeyHandler = (e) => {
        if (e.code === 'Escape') {
            e.preventDefault();
            closeGlossaryPop();
        }
    };
    const openGlossaryPop = (id, offsetY, offsetX, elsize) => {
        //Calculate position
        offsetX = offsetX - document.getElementById('contentContainer').offsetLeft;
        const size = document.getElementById('contentContainer').scrollWidth;
        let isRight = size / 2 < offsetX;
        let bubble = 50;
        offsetY = offsetY - document.getElementById('contentContainer').offsetTop + 25;
        isRight ? offsetX = size - offsetX - 70 : offsetX = offsetX - 50;
        if (size < 500) {
            bubble = offsetX + elsize / 2;
            offsetY = offsetY + 10;
            offsetX = null;
        }
        try {
            document.querySelector(`[data-content="${id}"]`).setAttribute('aria-expanded', 'true');
            setGlossaryItem(glossaryTermsArr[parseInt(id)]);
            setGlossaryPosition({ offsetX, offsetY, opacity: 1, isRight, bubble });
            window.addEventListener('resize', closeGlossaryPop);
            document.querySelector('#glossarypop h4').focus();
        }
        catch (error) {
            // ignore
        }
    };
    const closeGlossaryPop = () => {
        document.querySelectorAll(`[data-content]`).forEach(e => e.setAttribute('aria-expanded', 'false'));
        window.removeEventListener('resize', closeGlossaryPop);
        setGlossaryItem({
            'title': '',
            'url': '',
            'description': '',
            'hasMainbody': false
        });
        setGlossaryPosition({
            offsetX: 0,
            offsetY: 0,
            opacity: 0,
            isRight: false,
            bubble: 0
        });
    };
    const openPop = (e) => {
        let target = e.target;
        let y = e.pageY;
        let x = e.pageX;
        if (e.pageX === 0) {
            y = target.getBoundingClientRect().top + window.scrollY + target.scrollHeight;
            x = target.getBoundingClientRect().left + window.scrollX + target.scrollWidth / 2;
        }
        openGlossaryPop(target.getAttribute('data-content'), y, x, target.offsetWidth);
    };
    const toggleGlossary = () => {
        if (document.querySelectorAll('*[data-glenabled=true]:not(*[data-glcalculated=true])').length > 0) {
            document.querySelectorAll('*[data-glenabled=true]:not(*[data-glcalculated=true])').forEach((el) => {
                if (el.clientHeight > 0 || el.clientWidth > 0)
                    findTextNodes(el);
                el.setAttribute('data-glcalculated', 'true');
            });
            document.querySelectorAll('.glossaryActive').forEach((e) => {
                e.addEventListener('click', openPop);
                e.removeAttribute('disabled');
            });
        }
        document.getElementById('epi-page-container').classList.add('glActive');
    };
    const removeFoundInformation = () => {
        if (glossaryTermsArr) {
            const glossaryTerms = [...glossaryTermsArr];
            glossaryTerms.forEach((s) => {
                s.found = false;
            });
            return glossaryTerms;
        }
    };
    const closeGlossary = () => {
        document.getElementById('epi-page-container').classList.remove('glActive');
        document.querySelectorAll('.glossaryActive').forEach((e) => {
            e.removeEventListener('click', openPop);
            e.setAttribute('disabled', 'true');
        });
    };
    const getElements = () => {
        return document.querySelectorAll('*[data-glenabled=true]');
    };
    const initGlossary = () => {
        let elements;
        const start = () => {
            if (elements.length > 0) {
                elements.forEach((el) => {
                    el.setAttribute('data-glcalculated', 'false');
                });
                toggleGlossary();
            }
        };
        // TODO: Figure out a way to get rid of timer. 
        // Problem is: How to know that all components at the page have rendered when we are not aware of components at the page when starting to render?  
        if (glossaryTermsArr) {
            !elements || elements.length === 0 ? setTimeout(() => {
                elements = getElements();
                if (elements.length > 0)
                    start();
            }, 0) : start();
        }
    };
    if (!ctx.isServerSideRendering())
        (0, useOnClickOutside_1.default)(popRef, () => closeGlossaryPop());
    (0, react_1.useEffect)(() => {
        setTimeout(() => {
            if (!initialized) {
                initialized = true;
                if (glossaryState && !firstRender && glossaryTermsArr) {
                    document.querySelectorAll('button.glossaryActive').forEach(e => e.replaceWith(e.innerText));
                    setGlossaryTermsArr(removeFoundInformation());
                    //TODO: Bit problematic timeout. It might be that we have already done checks and after that new content is fetched from BE and we are updating page content with it.
                    // It results --> glossary words are disappearing...
                }
                else if (glossaryState && !glossaryTermsArr && firstRender) {
                    const glossaryFilter = 'ContentType/any(t:t eq \'GlossaryTermPage\')';
                    const glossaryTerms = [];
                    api.basicSearch('', glossaryFilter, 'startPublish desc', 0).then(x => {
                        x.results.forEach((g) => {
                            var _a, _b, _c;
                            glossaryTerms.push({
                                title: g.name.toString(),
                                url: g.contentLink.url,
                                description: (_a = g.description) === null || _a === void 0 ? void 0 : _a.value,
                                hasMainbody: g.mainBody.value !== '',
                                terms: ((_b = g.term) === null || _b === void 0 ? void 0 : _b.value) !== '' ? (_c = g.term) === null || _c === void 0 ? void 0 : _c.value.split('\n') : null,
                                found: false
                            });
                        });
                        glossaryTerms.forEach((s, i) => {
                            if (s.terms)
                                s.terms.forEach((t, r) => {
                                    glossaryTerms[i].terms[r] = t.replace(new RegExp('[(]|[)]', 'g'), '\\$&');
                                });
                        });
                        setGlossaryTermsArr(glossaryTerms);
                        setFirstRender(false);
                    });
                }
                else if (glossaryState) {
                    document.querySelectorAll('button.glossaryActive').forEach(e => e.replaceWith(e.innerText));
                    setGlossaryTermsArr(removeFoundInformation());
                }
                if (!glossaryState)
                    closeGlossary();
            }
        }, 1000);
        return () => {
            document.querySelectorAll('.glossaryActive').forEach((e) => {
                e.removeEventListener('click', openPop);
            });
            setFirstRender(true);
            glossaryState = false;
        };
    }, [glossaryState, location.pathname, location.search]);
    (0, react_1.useEffect)(() => {
        if (glossaryTermsArr)
            initGlossary();
    }, [glossaryTermsArr]);
    if (glossaryItem.title === '')
        return react_1.default.createElement(react_1.default.Fragment, null);
    const positionInline = {
        top: glossaryPosition.offsetY,
        left: !glossaryPosition.isRight ? glossaryPosition.offsetX : 'auto',
        right: glossaryPosition.isRight ? glossaryPosition.offsetX : 'auto',
        opacity: glossaryPosition.opacity
    };
    const bubble = {
        left: !glossaryPosition.isRight ? glossaryPosition.bubble : 'auto',
        right: glossaryPosition.isRight ? glossaryPosition.bubble : 'auto',
    };
    return react_1.default.createElement("div", { id: 'glossarypop', className: 'glossaryPop position-absolute py-9 ps-8 pe-9 mx-5', ref: popRef, onKeyDown: backToMenuKeyHandler, style: positionInline },
        react_1.default.createElement("h4", { tabIndex: -1, className: 'mb-6' }, glossaryItem.title),
        react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: glossaryItem.description } }),
        react_1.default.createElement("a", { id: 'glossarylink', href: `${(_f = props.settings.glossaryPageUrl) === null || _f === void 0 ? void 0 : _f.value}?term=${encodeURIComponent(glossaryItem.title.replace(/ /g, '_'))}`, target: '_self' }, typeof ((_g = props.settings.toGlossaryPage) === null || _g === void 0 ? void 0 : _g.value) === 'string' ? (_h = props.settings.toGlossaryPage) === null || _h === void 0 ? void 0 : _h.value : props.settings.toGlossaryPage),
        react_1.default.createElement("div", { className: 'bubble', style: bubble }));
};
exports.GlossaryService = GlossaryService;
exports.default = exports.GlossaryService;
